export function getDefaultOptions() {
  return {
    dateStart: false,
    dateEnd: false,
    filterActive: true,
    filterChip: false,
    filterDriver: false,
    filterFrequency: false,
    filterImaOperations: false,
    filterMultiple: false,
    filterMultipleVirtualFence: false,
    filterNiple: false,
    filterNipleFky: false,
    filterPatrimony: false,
    filterPump: false,
    filterSavedArea: false,
    filterPreSelected: false,
    filterRoute: false,
    filterSpeeding: false,
    filterUser: false,
    filterVirtualFence: false,
    layout: true
  };
};

export function getDefaultOptionsChip() {
  const basic = getDefaultOptions();
  return Object.assign({}, basic, {
    filterChip: true
  });
}

export function getDefaultOptionsDriver() {
  const basic = getDefaultOptions();
  return Object.assign({}, basic, {
    filterDriver: true
  });
}

export function getDefaultOptionsPatrimony() {
  const basic = getDefaultOptions();
  return Object.assign({}, basic, {
    filterPatrimony: true
  });
}

export function getDefaultOptionsUser() {
  const basic = getDefaultOptions();
  return Object.assign({}, basic, {
    filterUser: true
  });
}
